import Vue from "vue";
import store from "@/store";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import zhCN from "vant/lib/locale/lang/zh-CN";
import VueI18n from "vue-i18n";
Vue.use(VueI18n); // 通过插件的形式挂载

// en.js
const L = require.context("@", true, /.*?\.i18n\.js$/);
const en = {};
const zh = {};
L.keys().forEach(key => {
  const slicing = key.substring(key.lastIndexOf("/") + 1);
  const name = slicing.substr(slicing, slicing.indexOf("."));
  const value = L(key).default;
  const e = {};
  const z = {};
  value.forEach(item => {
    e[item.name] = item.en;
    z[item.name] = item.zh;
  });
  // console.log(e, z);

  en[name] = e;
  zh[name] = z;
});

const i18n = new VueI18n({
  locale: store.getters.language, // 语言标识
  messages: {
    zh: zh, // 中文语言包
    en: en // 英文语言包
  }
});

// 更新组件库本身的语言变化，支持国际化
function setLocale(lang) {
  if (lang === "en") {
    Locale.use(lang, enUS);
  } else if (lang === "zh") {
    Locale.use(lang, zhCN);
  }
}
setLocale(i18n.locale);

export default i18n;
